import type { ItemUnitTranslationSigmaRequestEntity } from './ItemUnitTranslationEntity'
import type { VenderMiniEntity } from '@/features/vender/domain/entities/VenderMiniEntity'
import type { CategoryMiniEntity } from '@/features/category/domain/entities/CategoryMiniEntity'
import type { ItemAttributeEntity } from './ItemAttributeEntity'
import type { BranchEntity } from '@/features/branch/domain/entities/BranchEntity'
import type { CreateUpdateItemGalleryEntity } from './CreateUpdateItemGalleryEntity'
import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'
import type { ItemUnitMiniEntity } from '@/features/ItemUnits/domain/entities/ItemUnitsMiniEntity'
import type { ItemOrderSupportType } from '../enums/ItemOrderSupportType'
import type { ItemApprovalStatus } from '@/backend/market'
export class CreateUpdateItemEntity {
  barcode?: string | null
  imageData?: FileUploadEntity | null
  imageUrl?: string
  isAvailable?: boolean
  disabled?: boolean
  branch?: BranchEntity
  translations?: Array<ItemUnitTranslationSigmaRequestEntity> | null
  itemUnit?: ItemUnitMiniEntity | null;
  unitPrice?: number
  maxQuantityPerOrder?: number
  vender?: VenderMiniEntity
  inventoryQuantity?: number
  category?: CategoryMiniEntity
  itemGalleries?: Array<CreateUpdateItemGalleryEntity> | null
  attributes?: Array<ItemAttributeEntity>
  sku?: string | null
  notAvailableUntil?: string | null;
  externalBranchDiscountAmount?: number
  orderSupportType?: ItemOrderSupportType
  approvalStatus?: ItemApprovalStatus
}
